import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "rotate(180, 12, 12)",
		d: "M17 17L15.59 15.59L12.9999 18.17V2H10.9999V18.17L8.41 15.58L7 17L11.9999 22L17 17Z"
	})
});
export default SvgSortArrowUp;
